// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-controls {
    display: grid;
    grid-template-columns: 1fr 1fr auto 1fr 1fr;
    justify-items: center;
    align-items: center;

    max-width: 500px;
    margin: 20px auto;

    text-align: center;
    font-size: 16px;
}
.page-controls .control {
    display: inline-block;
    padding: 0 7px;
}
`, "",{"version":3,"sources":["webpack://./client/components/PaginationControls.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2CAA2C;IAC3C,qBAAqB;IACrB,mBAAmB;;IAEnB,gBAAgB;IAChB,iBAAiB;;IAEjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".page-controls {\n    display: grid;\n    grid-template-columns: 1fr 1fr auto 1fr 1fr;\n    justify-items: center;\n    align-items: center;\n\n    max-width: 500px;\n    margin: 20px auto;\n\n    text-align: center;\n    font-size: 16px;\n}\n.page-controls .control {\n    display: inline-block;\n    padding: 0 7px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
